/* User Role Accesses Details */
export const USER_ROLE_ACCESS_REQUEST = "USER_ROLE_ACCESS_REQUEST";
export const USER_ROLE_ACCESS_SUCCESS = "USER_ROLE_ACCESS_SUCCESS";

/* User Info Accesses Details */
export const USER_INFO_REQUEST = "USER_INFO_REQUEST";
export const USER_INFO_SUCCESS = "USER_INFO_SUCCESS";